<template>
    <div class="navigate-wrapper">
            <img
                    v-if="isDashboard"
          src="../../assets/images/navigate_dashboard_up.png"
          :height="size || 90"
          :width="size || 90"
                    @mouseover="getGeoParents"
  />
          <div uk-dropdown="pos: bottom-center">
            <ul class="uk-nav uk-dropdown-nav">
                <li v-for="(p, i) in parental_data"><a :href="p.url">{{p.name}}</a></li>
                <!--<li><a href = "#">Messages</a></li>-->
            </ul>
            </div>
    </div>
</template>

<script>

  import apiCall from '../../store/apicall.js'

    export default {
        name: "navigateUp",
        props: ['size', 'isDashboard'],
      data: function() {
		  return {
              parental_data: []
          }
      },
        computed: {
          currentGeography () {
              return this.$store.state.geography.data.slug
              // TODO: this is not updating properly...
          }
        },
        methods: {

            getGeoParents: function() {
                console.log("CURRENT GEO: ", this.currentGeography)
                this.parental_data = [];
                let _t = this;

                axios.post('/accounts/organizations/', {"slug": this.currentGeography}).then(function(response){
                    var data = response.data;

                    while (data['parent'] != null) {
                        data['parent']['url'] = '/dashboard/' + data['parent']['slug']
                        _t.parental_data.push(data['parent'])
                        data = data['parent']
                    }
                    console.log(_t.parental_data)
                })
            }
        }
    }
</script>

<style lang="less" scoped>

  @import "../../assets/less/palette.less";

  .wrapper {
    position: relative;
  }

  img {
    cursor: pointer;
    position: relative;
  }
    .navigate-wrapper{
        margin-right: 10px;
    }


</style>
